import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import ImageUpload from "@/components/ImageUpload";

import RichTextEditor from "@/components/RichTextEditor";
// Edit a past-stream replay (stored on its event): title, description, cover, topics, access, linked offering.
export default function ReplayEditModal({ item, offerings = [], onClose, onSaved }) {
  const e = item.edit || {};
  const [form, setForm] = useState({ title: e.title || item.title, description: e.description || "", featured_image: e.featured_image || "",
    tags: (e.tags || []).join(", "), access_level: e.access_level || "public", linked_service_id: e.linked_service_id || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (ev) => setForm((f) => ({ ...f, [k]: ev.target.value }));
  const submit = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    try {
      await api.put(`/media-hub/replays/${item.id}`, { ...form, tags: form.tags.split(",").map((t) => t.trim()).filter(Boolean) });
      toast.success("Replay updated");
      onSaved(); onClose();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Couldn't save"); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[100] grid place-items-center px-4 bg-black/40 backdrop-blur-sm overflow-y-auto py-10" data-testid="replay-edit-modal">
      <div className="relative w-full max-w-lg bg-[#F9F7F3] rounded-3xl shadow-2xl p-8 my-auto">
        <button onClick={onClose} aria-label="Close" className="absolute top-4 right-4 text-[#4A5D6B] hover:text-[#144F75]"><X size={20} /></button>
        <h3 className="font-serif text-2xl text-[#1A242B] mb-1">Edit replay</h3>
        <p className="text-sm text-[#4A5D6B] mb-4">Changes show on the Media page straight away. This also updates the event's title and description.</p>
        <form onSubmit={submit} className="space-y-3">
          <input required value={form.title} onChange={set("title")} placeholder="Title" data-testid="replay-title" className="eyw-input w-full" />
          <select value={form.access_level} onChange={set("access_level")} data-testid="replay-access" aria-label="Who can watch" className="eyw-input w-full">
            <option value="public">Public</option>
            <option value="members">Members and ticket holders</option>
            <option value="ticket">Ticket holders only</option>
          </select>
          <select value={form.linked_service_id} onChange={set("linked_service_id")} data-testid="replay-offering" aria-label="Linked offering" className="eyw-input w-full">
            <option value="">Link to an offering (optional)</option>
            {offerings.map((o) => <option key={o.id} value={o.id}>{o.title}</option>)}
          </select>
          <input value={form.tags} onChange={set("tags")} placeholder="Topics, comma separated" data-testid="replay-tags" className="eyw-input w-full" />
          <ImageUpload value={form.featured_image} onChange={(u) => setForm((f) => ({ ...f, featured_image: u }))} label="Cover image" testid="replay-cover" />
          <RichTextEditor value={form.description} onChange={(v) => setForm((f) => ({ ...f, description: v }))} testid="replay-desc" placeholder="Description" minHeight={100} enableBlocks={false} media={false} />
          <button type="submit" disabled={busy} data-testid="replay-save" className="eyw-btn w-full disabled:opacity-60">{busy && <Loader2 size={16} className="animate-spin" />} Save changes</button>
        </form>
      </div>
    </div>
  );
}
